export default __webpack_public_path__ + "static/media/hexagon-inner-5.ab47dd1e.svg";